import service from "@hybird/core/request";
import url from "@hybird/device/request";
import {OperationDeviceMethodInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";

export class FirmwareUpgradeOperationInterceptor extends OperationDeviceMethodInterceptor {

  async firmwareUpgrade(proceed, self, {type = 1, localCallback, path, data, success, complete, message, fail, timeout} = {}) {
    if (!data) {
      const result = await service.getFrom(url.firmwareUpgrade, {
        number: this.deviceInfo.number
      })

      let firmwareUpgradeData = result.data;

      if (type === 2) {
        firmwareUpgradeData = result.data.systemFirmwareDTO;
      }


      if (type === 1) {
        return proceed({type, data: firmwareUpgradeData, localCallback, path,success, complete, message, fail, timeout});
      } else if (type === 2) {
        return proceed({type, data: firmwareUpgradeData, localCallback, path,success, complete, message, fail, timeout});
      } else {
        throw WebError.code(deviceError.FIRMWARE_UPGRADE_NOT_SUPPORT)
      }
    } else {
      return proceed({type, data: data, localCallback,path, success, complete, message, fail, timeout});
    }
  }

  isSupport(self) {
    return true;
  }
}
